/**
 * List of events used by faq top questions widget
 *
 */
export const faqTopQuestions = {
  QUESTION_TOGGLED: 'faqTopQuestions.question'
}
